import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/head.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import ShapeIcon from '@static/icon/shape01.png';

interface IProps {
  title: string,
  bigTitle: string,
  right?: string,
}
interface IState {}

const Head = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title, bigTitle, right } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="title-111">
      <p className="big-111">
        <img src={ShapeIcon} alt="" />
        <strong>{title}</strong>
      </p>
      <p className="title-113">
        <span className="span-11" />
        <b>{bigTitle}</b>
      </p>
      {right || ''}
    </section>
  );
};

export default observer(Head);
